import React from 'react';
import View from './view';
import { useSelector } from '../../Hooks';

/**
 * LeatLoyalty scene
 */

const LeatLoyalty = () => {
  const { user } = useSelector((state) => state);

  return <View userId={user?.id} />;
};

export default LeatLoyalty;
